<template>
  <div class="product-item" :data-collections="product.category" @click="$emit('click')">
    <div class="product-item-img-container">
      <img :src="product.image" :alt="product.name">
      <div class="product-labels">
        <label v-for="(label, index) in product.labels" :key="index" :class="['product-label', label.toLowerCase()]">{{ label }}</label>
      </div>
    </div>
    <div class="product-item-content">
      <p class="collections-name">{{ product.collection }}</p>
      <p class="product-name">{{ product.name }}</p>
      <div v-if="saleType === 'wholesale'">
        <p class="product-price">請洽客服</p>
      </div>
      <div v-else>
        <p v-if="product.salePrice" class="product-price original">$NTD {{ product.price }}</p>
        <p :class="['product-price', product.salePrice ? 'sale' : '']">{{ product.salePrice ? '$' + product.salePrice : '$' + product.price }}</p>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      required: true
    },
    saleType: {
      type: String,
      default: 'retail'
    }
  }
}
</script>

<style scoped>
.product-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.product-item:hover {
  transform: translateY(-5px);
}
</style> 